import gql from 'graphql-tag'

export const GET_BUNDLE_OFFERS_PAGINATED = gql`
  query GetBundleOffersPaginated(
    $organizationSlug: String!
    $pagination: Pagination!
    $searchTerm: String
  ) {
    getBundleOffersByOrganizationSlug(
      organizationSlug: $organizationSlug
      pagination: $pagination
      searchTerm: $searchTerm
    ) {
      items {
        id
        quantityInterval
        freeQuantity
        totalQuantity
        quantityPerOrder
        active
        quantityUsed
        from
        to
        eventId
        event {
          id
          title
          from
          eventTemplateId
        }
        orderItem {
          id
          name
        }
      }
      totalCount
    }
  }
`

export const CREATE_BUNDLE_OFFER = gql`
  mutation CreateBundleOffer(
    $eventId: ID!
    $quantityInterval: Int!
    $freeQuantity: Int!
    $unlimitedQuantity: Boolean!
    $from: String!
    $to: String!
    $orderItemId: ID!
    $totalQuantity: Int
    $quantityPerOrder: Int
    $active: Boolean
  ) {
    createBundleOffer(
      eventId: $eventId
      quantityInterval: $quantityInterval
      freeQuantity: $freeQuantity
      unlimitedQuantity: $unlimitedQuantity
      from: $from
      to: $to
      orderItemId: $orderItemId
      totalQuantity: $totalQuantity
      quantityPerOrder: $quantityPerOrder
      active: $active
    ) {
      id
    }
  }
`

export const UPDATE_BUNDLE_OFFER = gql`
  mutation UpdateBundleOffer(
    $id: ID!
    $quantityInterval: Int
    $freeQuantity: Int
    $unlimitedQuantity: Boolean
    $from: String
    $to: String
    $orderItemId: ID
    $eventId: ID
    $totalQuantity: Int
    $quantityPerOrder: Int
    $active: Boolean
  ) {
    updateBundleOffer(
      id: $id
      quantityInterval: $quantityInterval
      freeQuantity: $freeQuantity
      unlimitedQuantity: $unlimitedQuantity
      from: $from
      to: $to
      orderItemId: $orderItemId
      eventId: $eventId
      totalQuantity: $totalQuantity
      quantityPerOrder: $quantityPerOrder
      active: $active
    ) {
      id
    }
  }
`

export const UPDATE_BUNDLE_OFFER_STATUS = gql`
  mutation UpdateBundleOfferStatus($organizationSlug: String!, $id: ID!, $active: Boolean!) {
    updateBundleOfferStatus(organizationSlug: $organizationSlug, id: $id, active: $active) {
      id
      active
    }
  }
`
